import React from "react";

/**
 * WhatsApp-style message status ticks.
 * status: "sent"      → 1 gray  tick
 * status: "delivered" → 2 gray  ticks
 * status: "read"      → 2 blue  ticks
 */
const MessageTick = ({ status }) => {
    if (!status || status === "sending") {
        return (
            // Clock icon — still uploading (optional)
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" className="inline-block ml-1 opacity-60">
                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                <polyline points="12 6 12 12 16 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
        );
    }

    const color = status === "read" ? "#60a5fa" : "currentColor"; // blue-400 or white/inherit
    const opacity = status === "sent" ? 0.6 : 1;

    // Single tick for "sent"
    if (status === "sent") {
        return (
            <svg
                width="16" height="11"
                viewBox="0 0 16 11"
                fill="none"
                className="inline-block ml-1"
                style={{ opacity, color }}
            >
                <path d="M1 5.5L5.5 10L15 1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        );
    }

    // Double tick for "delivered" and "read"
    return (
        <svg
            width="20" height="11"
            viewBox="0 0 20 11"
            fill="none"
            className="inline-block ml-1"
            style={{ color }}
        >
            {/* First (back) tick */}
            <path d="M1 5.5L5.5 10L15 1" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            {/* Second (front) tick — offset right */}
            <path d="M5 5.5L9.5 10L19 1" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export default MessageTick;
